import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=dd3be60a&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"
import style0 from "./Price.vue?vue&type=style&index=0&id=dd3be60a&prod&lang=css"
import style1 from "./Price.vue?vue&type=style&index=1&id=dd3be60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3be60a",
  null
  
)

export default component.exports